<p-panel header="Select Provider Address">
  <p-table
    selectionMode="single"
    [value]="providers"
    [paginator]="true"
    [rows]="10"
    (onRowSelect)="selectProvider($event.data)"
    data-test-id="provider-address-table"
    >
    <ng-template pTemplate="header">
      <tr>
        @for (col of cols; track col) {
          <th>
            {{col.header}}
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-provider>
      <tr [pSelectableRow]="provider">
        @for (col of cols; track col) {
          <td>
            @switch (col.field) {
              @case ('phone') {
                {{ provider.physicianAccountDTO[col.field] | phoneNumber }}
              }
              @case ('physicalZip') {
                {{ provider.physicianAccountDTO[col.field] | zipCode }}
              }
              @case ('accountName') {
                <span
                  [pTooltip]="provider.physicianAccountDTO[col.field]"
                  tooltipStyleClass="tooltip-xl-size"
                  tooltipPosition="bottom"
                  >
                  {{ provider.physicianAccountDTO[col.field] }}
                </span>
              }
              @case ('physicalStreet') {
                <span
                  [pTooltip]="provider.physicianAccountDTO[col.field]"
                  tooltipStyleClass="tooltip-xl-size"
                  tooltipPosition="bottom"
                  >
                  {{ provider.physicianAccountDTO[col.field] }}
                </span>
              }
              @default {
                {{ provider.physicianAccountDTO[col.field] }}
              }
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</p-panel>
